export const ACCOUNT_ENDPOINT_GET_USER = '/api/auth/get-user';
export const ACCOUNT_ENDPOINT_UPDATE_USER = '/api/auth/update-user';
export const ACCOUNT_ENDPOINT_UPDATE_USER_PASSWORD = '/api/auth/update-user-password';
